export const TestIds = {
  root: 'icon-root',
};
